module.exports = __webpack_public_path__ + "media/images/emoticons/bag-573c4311aba509616ddfd714f0cf03ab.gif";